"use client";
import React, { useEffect } from "react";
import loadBackgroudImages from "../../common/loadBackgroudImages";
import { Link } from "react-router-dom";
function Header() {
  useEffect(() => {
    loadBackgroudImages();
  }, []);
  return (
    <header
      className="header-personal valign bg-img bg-img-center"
      data-background="/assets/imgs/header/p0-new.png"
      data-overlay-dark="2"
    >
      <div className="container ontop">
        <div className="row">
          <div className="col-lg-7">
            <div className="caption">
              <h6 className="mb-15">
                <span className="icon-img-30 mr-10">
                  <img src="/assets/imgs/header/hi.png" alt="" />
                </span>{" "}
                Hello! there
              </h6>
              <h1 className="fw-700 mb-10">
                I&apos;m Nithin{" "}
                <span className="main-color">Namani</span>
              </h1>
              <h3>I am a UX Designer</h3>
              <div className="row">
                <div className="col-lg-9">
                  <div className="text mt-30">
                    <p>
                      With 4+ years of experience, I design user-centered
                      digital products that integrate accessibility, scalable
                      design systems, and business-driven results.
                    </p>
                  </div>
                  <div className="d-flex align-items-center mt-60">
                    <Link
                      to="/contact"
                      className="butn butn-md butn-bord radius-30"
                    >
                      <span className="text">Contact Me</span>
                    </Link>
                    <div className="icon-img-60 ml-20">
                      <img
                        src="/assets/imgs/icon-img/arrow-down-big.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="info d-flex align-items-center justify-content-end mt-100">
          <div className="item">
            <h6 className="sub-title mb-10">Email :</h6>
            <span className="p-color"> nithinnamani994@gmail.com</span>
          </div>
          <div className="item">
            <h6 className="sub-title mb-10">Phone :</h6>
            <span className="p-color">+1 (717) 567-1773</span>
          </div>
          <div className="item">
            <h6 className="sub-title mb-10">Address :</h6>
            <span className="p-color">Carlisle, PA, United States.</span>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
